import BaseView from "../base_view";

export default class JobPostBaseView extends BaseView {
  public mount() {
    super.mount();
    console.log("JobPost Base View Mounted");
  }

  public addWindowFunctions() {
    super.addWindowFunctions();
  }

  public unmount() {
    super.unmount();
    console.log("MainView unmounted");
  }
}
